import { render, staticRenderFns } from "./PageRestaurants.vue?vue&type=template&id=c284c3b0&scoped=true&"
import script from "./PageRestaurants.vue?vue&type=script&lang=ts&"
export * from "./PageRestaurants.vue?vue&type=script&lang=ts&"
import style0 from "./PageRestaurants.vue?vue&type=style&index=0&id=c284c3b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c284c3b0",
  null
  
)

export default component.exports